/**
 * This files sets up the global variables and system import for widgets
 * Adding all the ts-polyfills and ts libs and making them globally available
 */

// Required polyfills to work in IE
import 'ts-polyfill/lib/es2015-core';
import 'ts-polyfill/lib/es2015-promise';
// Nice to have polyfills not required
import 'ts-polyfill/lib/es2015-collection';
import 'ts-polyfill/lib/es2016-array-include';
import 'ts-polyfill/lib/es2017-string';
import 'ts-polyfill/lib/es2017-object';
import 'ts-polyfill/lib/es2018-promise';

import * as tslib from 'tslib';
import System from './system';
import * as vev from './core';
import React from 'react';
import ReactDOM from 'react-dom';
import animejs from 'animejs';

System.add({
  vev,
  react: { default: React, ...React },
  'react-dom': { default: ReactDOM, ...ReactDOM },
  animejs: { default: animejs }
});

(<any>window).__extends = tslib.__extends;
(<any>window).__assign = tslib.__assign;
(<any>window).__rest = tslib.__rest;
(<any>window).__decorate = tslib.__decorate;
(<any>window).__param = tslib.__param;
(<any>window).__metadata = tslib.__metadata;
(<any>window).__awaiter = tslib.__awaiter;
(<any>window).__generator = tslib.__generator;
(<any>window).__exportStar = tslib.__exportStar;
(<any>window).__values = tslib.__values;
(<any>window).__read = tslib.__read;
(<any>window).__spread = tslib.__spread;
(<any>window).__await = tslib.__await;
(<any>window).__asyncGenerator = tslib.__asyncGenerator;
(<any>window).__asyncDelegator = tslib.__asyncDelegator;
(<any>window).__asyncValues = tslib.__asyncValues;
(<any>window).__makeTemplateObject = tslib.__makeTemplateObject;
(<any>window).__importStar = tslib.__importStar;
(<any>window).__importDefault = tslib.__importDefault;

(<any>window).System = System;
(<any>window).React = React;
(<any>window).ReactDOM = ReactDOM;
